import { ResourceStatus } from 'json-api-hooks';
import React from 'react';

import Container from '../Container';
import RouteNotFound from '../Routes/RouteNotFound';

import ErrorCard from './ErrorCard';

const HEADERS: Partial<Record<ResourceStatus, string>> = {
  [ResourceStatus.Forbidden]: 'Geen toegang',
};

const ErrorPage = ({ status }: { status?: ResourceStatus }) => {
  if (status === ResourceStatus.NotFound) {
    return <RouteNotFound />;
  }

  return (
    <Container>
      <ErrorCard header={status ? HEADERS[status] : undefined} />
    </Container>
  );
};

export default ErrorPage;
